// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App'
import router from './router'
import store from './store'
import cookie from '@/utils/cookie.js'
import Antd from 'ant-design-vue';

import { pca,pcaa } from 'area-data'
import VueAreaLinkage from 'vue-area-linkage'
import 'vue-area-linkage/dist/index.css';
Vue.use(Antd);
Vue.use(VueAreaLinkage);
Vue.prototype.Cookies = cookie
// Vue.use(Cookie)

Vue.use(ElementUI, {
	size: 'small',
	zIndex: 3000
});

Vue.config.productionTip = false

// 金额补零
Vue.filter('amounts', function(val) {
	if (val) {
		return Number(val).toFixed(2)
	} else {
		return '0.00'
	}
})

/* eslint-disable no-new */
export default new Vue({
	el: '#app',
	router,
	components: {
		App
	},
	template: '<App/>',
	store
})



// WEBPACK FOOTER //
// ./src/main.js